import { render, staticRenderFns } from "./SafetyAccidentList.vue?vue&type=template&id=6f46c418&scoped=true"
import script from "./SafetyAccidentList.vue?vue&type=script&lang=js"
export * from "./SafetyAccidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f46c418",
  null
  
)

export default component.exports